import React from 'react';
import { styled } from '@mui/material';

import { useUser2 } from 'contexts/user2';
import { Button, Checkbox, Divider, IconButton, Radio, RadioGroup, Stack, Text } from 'shell/components';
import { getUserPreferredFullName } from 'utils/helper';

const FilesFilter = ({ filters, setFilters }) => {
    const { currentGroupAccountUsers, instructorAccountUsers } = useUser2();
    const accountUsers = [...currentGroupAccountUsers, ...instructorAccountUsers];

    let checkedFiltersCount = 0;
    if (filters.types.length) checkedFiltersCount++;
    if (filters.owners.length) checkedFiltersCount++;

    return (
        <Stack divider={<Divider />} spacing={4}>
            <Stack>
                <IconButton
                    aria-label={'close'}
                    sx={{ alignSelf: 'flex-end' }}
                    kind={'exit'}
                    size={'medium'}
                    variant={'square'}
                    onClick={() => setFilters((current) => ({ ...current, open: false }))}
                />
                <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                    <Text variant={'h6'} weight={'semibold'}>
                        Sort By
                    </Text>
                    <Button
                        variant={'tertiary'}
                        onClick={() => {
                            setFilters((current) => ({
                                ...current,
                                sort: 'latest',
                                types: [],
                                owners: [],
                            }));
                        }}
                    >
                        Reset All
                    </Button>
                </Stack>
                <Stack>
                    <CustomRadioGroup
                        value={filters.sort}
                        onChange={(_, value) => setFilters((current) => ({ ...current, sort: value }))}
                    >
                        <Radio label={'Latest'} labelPlacement={'start'} value={'latest'} />
                        <Radio label={'Earliest'} labelPlacement={'start'} value={'earliest'} />
                        <Radio label={'Name A-Z'} labelPlacement={'start'} value={'namea-z'} />
                        <Radio label={'Name Z-A'} labelPlacement={'start'} value={'namez-a'} />
                    </CustomRadioGroup>
                </Stack>
            </Stack>
            <Stack>
                <Text variant={'h6'} weight={'semibold'}>
                    Filters {checkedFiltersCount ? `(${checkedFiltersCount})` : ''}
                </Text>
                <CustomText color={'light'} variant={'p1'}>
                    Type
                </CustomText>
                <CustomStack>
                    <Checkbox
                        checked={filters.types.includes('file')}
                        label={'File'}
                        labelPlacement={'start'}
                        onChange={(_, checked) => {
                            setFilters((current) => ({
                                ...current,
                                types: checked
                                    ? [...current.types, 'file']
                                    : current.types.filter((key) => key !== 'file'),
                            }));
                        }}
                    />
                    <Checkbox
                        checked={filters.types.includes('link')}
                        label={'Website Link'}
                        labelPlacement={'start'}
                        onChange={(_, checked) => {
                            setFilters((current) => ({
                                ...current,
                                types: checked
                                    ? [...current.types, 'link']
                                    : current.types.filter((key) => key !== 'link'),
                            }));
                        }}
                    />
                </CustomStack>
                <CustomText color={'light'} variant={'p1'}>
                    Uploaded By
                </CustomText>
                <CustomStack>
                    {accountUsers.map((accountUser) => (
                        <Checkbox
                            key={accountUser.owner_account_id}
                            checked={filters.owners.includes(accountUser.owner_account_id)}
                            label={getUserPreferredFullName(accountUser)}
                            labelPlacement={'start'}
                            onChange={(_, checked) => {
                                setFilters((current) => ({
                                    ...current,
                                    owners: checked
                                        ? [...current.owners, accountUser.owner_account_id]
                                        : current.owners.filter((key) => key !== accountUser.owner_account_id),
                                }));
                            }}
                        />
                    ))}
                </CustomStack>
            </Stack>
        </Stack>
    );
};

const CustomRadioGroup = styled(RadioGroup)(() => {
    return {
        '& label': {
            justifyContent: 'space-between',
        },
    };
});

const CustomText = styled(Text)(({ theme }) => {
    return {
        margin: theme.spacing(2, 0, 1),
    };
});

const CustomStack = styled(Stack)(({ theme }) => {
    return {
        paddingLeft: theme.spacing(2),
        '& label': {
            justifyContent: 'space-between',
        },
    };
});

export default FilesFilter;
